import { cn } from '../../lib/cn';
import type { SecurityRow } from '../../platformadmin/framework';

type Props = { items?: SecurityRow[] };

export function SecurityCompliancePanel({ items = [] }: Props) {
  return (
    <div className="grid gap-3 grid-cols-2 sm:grid-cols-4">
      {items.map((s) => (
        <div key={s.label} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <p className="text-xs text-slate-500">{s.label}</p>
          <p className="mt-1 text-lg font-semibold">{s.score}%</p>
          <p className={cn(
            'text-xs font-medium capitalize',
            s.score >= 95 ? 'text-success-600' : s.score >= 85 ? 'text-brand-600' : 'text-warning-600',
          )}>
            {s.status}
          </p>
        </div>
      ))}
    </div>
  );
}
